import React, { Component } from 'react'
import styles from './doorStatusPill.module.scss'
import moment from 'moment'
import { SwitchTransition, CSSTransition } from "react-transition-group"

import RecurrenteIcon from '../../img/icons/recurrente.svg'
import RecurrenteRedIcon from '../../img/icons/recurrente-red.svg'
import TemporaryIcon from '../../img/icons/temporal.svg'
import TemporaryRedIcon from '../../img/icons/temporal-red.svg'
import LockIcon from '../../img/icons/lock_closed.svg'
import LockOpenIcon from '../../img/icons/lock_open.svg'
import InfiniteIcon from '../../img/icons/infinite-icon.svg'
import ProximityIcon from '../../img/icons/proximity-icon.svg'
import LowBatteryIcon from '../../img/icons/low_battery.svg'

import API from '../utils/API'
import { Utils } from '../utils/utils'
import Loader from '../Loader'
import SSE from '../utils/SSE'

const GUEST_UNLIMITED = 1;
const GUEST_TEMPORARY = 2;
const GUEST_RECURRENT = 3;

const ACTIVITY_CIRCUIT_CLOSED = "CIRCUIT_CLOSED";
const ACTIVITY_CIRCUIT_OPENED = "CIRCUIT_OPENED";
const ACTIVITY_TRIGGER_DOOR = "TRIGGER_DOOR";


export default class DoorStatusPill extends Component
{
    constructor(props)
    {
        super(props)
        
        this.state =
        {
            isOpen: null,
            changeStatusAt: null
        }
        
        this.startPermissionTimer = null
        this.endPermissionTimer = null
        
        this.onLiveEventReceived = this.onLiveEventReceived.bind(this)
    }
    
    componentDidMount()
    {
        this.setCanTriggerDoorNow()
        this.getDoorOpen()
        this.subscribeToLiveEvents()
    }
    componentDidUpdate(prevProps, prevState)
    {
        if (this.props.door !== prevProps.door)
        {
            this.unsubscribeToLiveEvents(prevProps.door.id)
            this.setCanTriggerDoorNow()
            this.getDoorOpen()
            this.subscribeToLiveEvents()
        }
    }
    componentWillUnmount()
    {
        this.unsubscribeToLiveEvents()
    }
    
    render()
    {
        var canTriggerDoorIcon = <img className={styles.icon} src={InfiniteIcon} alt=""/>;

        if (this.props.door.roleType == 'guest')
        {
            var permissionType = Utils.getGuestPermissionType(this.props.door.myPermission);

            if (permissionType == GUEST_TEMPORARY)
                canTriggerDoorIcon = (this.state.canTriggerDoorNow) ?
                    <img src={TemporaryIcon} alt="Permiso Temporal" /> :
                    <img src={TemporaryRedIcon} alt="Permiso Temporal" />;
            else if (permissionType == GUEST_RECURRENT)
                canTriggerDoorIcon = (this.state.canTriggerDoorNow) ?
                    <img src={RecurrenteIcon} alt="Permiso Recurrente" /> :
                    <img src={RecurrenteRedIcon} alt="Permiso Recurrente" />;
            else if (permissionType == null)
                canTriggerDoorIcon = null;
        }

        var isOpenIconView = null
        if (this.props.door.roleType !== 'guest' && this.state.isOpen != null)
        {
            let icon = (this.state.isOpen) ? LockOpenIcon : LockIcon;
            isOpenIconView = <SwitchTransition>
                                <CSSTransition key={`${this.state.isOpen}`} classNames='fade' timeout={500}>
                                    <img src={icon} alt=""/>
                                </CSSTransition>
                             </SwitchTransition>
        }

        var proximityView = null;
        if (this.state.proximityEnabled)
        {
            proximityView = <img className={styles.icon} src={ProximityIcon} alt=""/>
        }
        
        let batteryView = null
        if (this.props.door.roleType === 'admin' && this.props.door.node?.batteryStatus === 'low')
        {
            batteryView =
            <>
                <img className={styles.wide} src={LowBatteryIcon} alt="Low Battery"/>
                <div className={styles.separator}></div>
            </>
        }
        
        
        return (
            <div className={styles.iconsBox}>
                { batteryView }
                { /*proximityView*/ }
                { isOpenIconView }
                { canTriggerDoorIcon }
                { this.props.isTriggering && <Loader spinner gray /> }
                {/* <img className={styles.icon} src={BoxIcon} alt="Box icon"/>
                <img className={styles.icon} src={ProximityIcon} alt="Proximity icon"/>
                <img className={styles.icon} src={LockIcon} alt="Lock icon"/>
                <img className={styles.icon} src={EthernetIcon} alt="Ethernet icon"/>
                <img className={styles.icon} src={InfiniteIcon} alt="Infinite icon"/> */}
            </div>
        )
    }
    
    
    setCanTriggerDoorNow()
	{
		var canTrigger = false;
		var myPermission = this.props.door.myPermission;
		var roleType = this.props.door.roleType;

		var canTrigger = Utils.canTriggerDoorNow(roleType, myPermission);

		if (this.props.door.roleType == 'guest')
		{
			if (canTrigger.startTimerSecs != null && canTrigger.startTimerSecs <= (24*3600))
			{
				if (this.startPermissionTimer != null) clearTimeout(this.startPermissionTimer);
				this.startPermissionTimer = setTimeout(() => { this.setCanTriggerDoorNow(); }, canTrigger.startTimerSecs * 1000);
			}

			if (canTrigger.endTimerSecs != null && canTrigger.endTimerSecs <= (24*3600))
			{
				if (this.endPermissionTimer != null) clearTimeout(this.endPermissionTimer);
				this.endPermissionTimer = setTimeout(() => { this.setCanTriggerDoorNow(); }, canTrigger.endTimerSecs * 1000);
			}
		}

        this.setState({ canTriggerDoorNow: canTrigger.canTrigger });
    }
    getDoorOpen()
	{
		if (this.gettingDoorOpen) return
		
		this.gettingDoorOpen = true

		API.getInstance()
		.getDoorIsOpen(this.props.door.id)
		.then(response =>
		{            
            this.setIsOpen(response)         

			this.gettingDoorOpen = false
		})
		.catch(error =>
		{
			this.gettingDoorOpen = false
			console.log(error)
		})
    }
    setIsOpen({ isOpen, changeStatusAt })
	{
        if (changeStatusAt == null ||
            moment().diff(changeStatusAt, 'days') >= 28)
        {
            this.setState({ isOpen: null, changeStatusAt })
        }
        else
		    this.setState({ isOpen, changeStatusAt })
    }
    
    async subscribeToLiveEvents()
    {        
        SSE.getInstance().whenReady().then(() =>
        {
            SSE.getInstance().subscribeToDoorEvents(this.props.door.id, this.onLiveEventReceived)
        })
    }
    onLiveEventReceived(data)
	{
        if (data.sensorId != null)
		{
			let eventType = (data.value === 0) ? ACTIVITY_CIRCUIT_CLOSED : ACTIVITY_CIRCUIT_OPENED
			//activitySections = Utils.mergeActionsAndSensors(this.state.activitySections, { sensor: [{...data, isLiveEvent: true, eventType}] })
        
            this.setIsOpen({ isOpen: eventType === ACTIVITY_CIRCUIT_OPENED, changeStatusAt: data.date })
        }
	}
	unsubscribeToLiveEvents(doorId)
	{
        let finalDoorId = (doorId == null) ? this.props.door.id : doorId
		SSE.getInstance().unsubscribeToDoorEvents(finalDoorId, this.onLiveEventReceived)
	}
}